import PropTypes from 'prop-types';
import { Title } from '~/components';
import styles from './AboutIntro.scss';

export const AboutIntro = ({ title, description = null }) => (
  <div className={styles.AboutIntro} data-testid="AboutIntro">
    <Title id="title" className={styles.Title}>
      {title}
    </Title>
    {description && <p className={styles.description}>{description}</p>}
  </div>
);

AboutIntro.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
};
